import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AccessRoute } from "components";
import routes from "configs/routes";
import { canvasPages } from "./canvas";
import { schoologyPages } from "./schoology";
import { useDispatch, useLocation, useQueryParams } from "../../hooks";
import { setSearchType } from "./duck";
import { SearchMode } from "./canvas/pages/teacher/search-tool/duck";
import ErrorScreen from "./components/error/ErrorScreen";

export const ltiPages = [
  {
    path: routes.lti.error,
    key: routes.lti.error,
    component: ErrorScreen,
    exact: true,
  },
  ...canvasPages,
  ...schoologyPages,
];
const LTI: React.FC = () => {
  const [params] = useQueryParams();
  const dispatch = useDispatch();
  const searchMode: SearchMode = params.get("mode");
  const { pathname } = useLocation();
  const page = params.get<{ number?: number; size?: number }>("page", {});

  useEffect(() => {
    dispatch(setSearchType(searchMode));
  }, [searchMode]);

  React.useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 0);
  }, [pathname, page.number, page.size]);

  return (
    <Routes>
      {ltiPages.map((config) => (
        <Route
          path={config.path}
          element={
            <AccessRoute path={config.path}>
              <config.component />
            </AccessRoute>
          }
        />
      ))}
    </Routes>
  );
};

export default LTI;
